export default {
  pendingLoanRequests: {
    items: [],
    meta: {},
    loading: false,
    error: null,
  },
  approveLoanRequest: {
    loading: false,
    error: null,
    data: null,
  },
  amendLoanRequest: {
    loading: false,
    error: null,
    data: null,
  },
  singleLoanRequest: {
    loading: false,
    error: null,
    data: {},
  },
  loanInterest: {
    loading: false,
    error: null,
    data: {},
  },
  microLoanNotifications: {
    items: [],
    meta: {},
    loading: false,
    error: null,
  },
  readMicroLoanNotification: {
    loading: false,
    error: null,
    data: null,
  },
  readAllMicroLoanNotifications: {
    loading: false,
    error: null,
    data: null,
  },
  unreadNotificationsCount: 0,
};
